export default __webpack_public_path__ + "static/media/about-image-1.160afbe6.png";